import styled from '@emotion/styled';
import {
  Flex,
  StyledTopbarAvatar,
  StyledTopbarContainer
} from '@linearb/linui-common';
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';

export const PullRequestInput = styled(TextField)`
  width: 100%;
  height: 5rem;
  color: white;
  margin-bottom: ${({ error }) => (error ? '2rem' : '0rem')};
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: white;
  }
  & .MuiInputLabel-root.Mui-focused {
    color: white;
  }
  & .MuiFormHelperText-root {
    font-size: 1rem;
  }
`;

export const PlaygroundLayout = styled(Flex)`
  width: 90vw;
  height: ${({ isFullscreen }) => (isFullscreen ? '100vh' : '85vh')};
  margin: 5vh auto;
  flex-direction: column;
`;

export const RulesSelectionsContainer = styled(Flex)`
  width: 30%;
  min-width: 300px;
  flex-direction: column;
`;

export const InputContainer = styled(Flex)`
  flex-basis: 100%;
  gap: 15px;
`;

export const TitleComponent = styled(Flex)`
  flex-basis: 100%;
  align-items: baseline;
  gap: 4px;
`;

export const Title = styled.h1`
  color: white;
  margin: 0rem;
  font-weight: normal;
  font-family: 'Jura';
`;

export const SubTitle = styled.h1`
  color: white;
  margin: 0rem;
  font-size: 17px;
  font-weight: normal;
  font-family: 'Jura';
`;

export const OutputTitle = styled.h2`
  color: white;
  margin-bottom: 0;
  font-family: Menlo, Monaco, 'Courier New', monospace !important;
`;

export const ReloadButton = styled(Button)`
  color: white;
  font-size: 1.15rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid #5f41d9;
  background: linear-gradient(0deg, #1f2025, #1f2025),
    linear-gradient(0deg, #9747ff, #9747ff);
`;

export const RunButton = styled(Button)`
  font-size: 1.15rem;
`;

export const OutputContainer = styled.div`
  display: block;
  background-color: #1e1e1e;
  flex-basis: 30%;
  border: 1px solid #413e60;
  border-radius: 0.4rem;
  color: #d4d4d4;
  padding: 2rem;
  font-size: 1.25rem;
  height: ${({ isFullscreen }) => (isFullscreen ? '100vh' : '25vh')};
  overflow-y: auto;
  & * {
    font-family: Menlo, Monaco, 'Courier New', monospace !important;
  }
  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #2e2e2e;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #646464;
    border-radius: 6px;
    border: 3px solid #2e2e2e;
  }
`;

export const PlaygroundWrapper = styled.div`
  & ${StyledTopbarContainer} {
    flex-direction: row-reverse !important;
    margin: 0;
  }

  & ${StyledTopbarAvatar} {
    ${({ loggedIn }) => !loggedIn && `display: none;`}
  }
`;
